import { motion } from "framer-motion";

const ScrollNav = ({ color = "text-navylight", offset = 6 }) => {
  const scroll = (direction) => {
    const sections = Array.from(document.querySelectorAll("section[id]"));
    if (!sections.length) return;

    // find which section your scrollTop is closest to
    const scrollY = window.scrollY;
    const currentIndex = sections.findIndex((sec) => {
      const offsetTop = sec.offsetTop;
      const offsetBottom = offsetTop + sec.offsetHeight;
      return scrollY >= offsetTop - 10 && scrollY < offsetBottom - 10;
    });

    let targetIndex = currentIndex;

    if (direction === "down" && currentIndex < sections.length - 1) {
      targetIndex = currentIndex + 1;
    }

    if (direction === "up" && currentIndex > 0) {
      targetIndex = currentIndex - 1;
    }

    sections[targetIndex].scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div className="fixed left-6 bottom-10 md:bottom-20 z-[999] flex flex-col gap-0 items-center">
      {/* UP BUTTON */}
      <motion.div
        onClick={() => scroll("up")}
        animate={{ y: [-5, 0, -5] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        className={`text-navylight text-lg font-bold cursor-pointer`}
      >
        ↑
      </motion.div>

      {/* DOWN BUTTON */}
      <motion.div
        onClick={() => scroll("down")}
        animate={{ y: [0, 5, 0] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        className={`text-navylight  text-lg font-bold cursor-pointer`}
      >
        ↓
      </motion.div>
    </div>
  );
};

export default ScrollNav;
